var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "demo" } },
    [
      _c(
        "div",
        { staticClass: "links" },
        [
          _c("router-link", { attrs: { to: { name: "single" } } }, [
            _vm._v("Single Balloon")
          ]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { name: "multiple" } } }, [
            _vm._v("Multiple Balloons")
          ]),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "https://github.com/kevinwarne/vue-balloon" } },
            [_vm._v("Github")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71377baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71377baa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/Demo.vue
// module id = mQeu
// module chunks = 0